import { BrandKitStore, PlatformBrandKitStore } from '../types/brand-kit-types';

export const BRAND_KIT_PATH = 'content-lab/filestack/brand_kit';

export const EMPTY_BRAND_KIT: BrandKitStore = {
  id: null,
  background: [],
  intro_outro: [],
  fonts: [],
  colors: []
};

export const EMPTY_PLATFORM_BRAND_KIT: PlatformBrandKitStore = {
  availableBrandKits: [],
  isLoadingBrandKits: false,
  ftuxBrandKit: [{ ...EMPTY_BRAND_KIT }]
};
